import React from "react";
import Input from "./Input";
import styles from "../NotesPage.module.scss";
import Content from "./Content";

const Header = ({ search, setQuery,setNotes }) => {
  return (
    <div className={styles["note-app__header"]}>
 <Content setNotes={setNotes} />
      <div className={styles["note-search"]} >
     
        <Input
        
          value={search}
          onChange={setQuery}
          type="search"
          id="search_note"
          name="search_note"
          placeholder="Найти заметки..."
        />
      </div>
    </div>
  );
};

export default Header;
